import React, { useCallback, useContext, useEffect, useState } from "react";
import { errorSchema, utils } from "helper";
import {
  CommonInput,
  CommonModal,
  CommonTextarea,
  CustomSelect,
} from "components";
import StorageService from "utils/StorageServices/StorageServices";
import toast, { Toaster } from "react-hot-toast";
import { createMaterialCategory } from "_services/materialServices/materialCategoryServices";
import { addExpenseApi, podReceivedData, updateLrProcess, uploadFiles } from "_services";
import { RiAddLargeFill } from "react-icons/ri";
import { createZone } from "_services/accountsServices/zoneServices";
import { getFastagCompanyDropdownData, getFuelCompanyDropdownData } from "_services/accountsServices/fuelStationServices";
import { StorageServices } from "utils";

const formObj = {
  company_id: StorageService.getCompanyId(),
  name: "",
  // fastag_company_id: "",
};

const AddExpenseCategoryModal = (props) => {
  const {
    isOpen,
    closeModal,
    nextModal,
    placeholder,
    label,
    ApiPoint,
    callBackApi,
    titleName = "",
    payloadData = {},
    isLabelData,
    fuelCardCompanyList = [],
    fastagCompanyList = [],
    branchList = []
  } = props;
  const [formValue, setFormValue] = useState(formObj);
  const [formError, setFormError] = useState({});
  const [loading, setLoading] = useState(false);

  const handleOnChange = async (name, value) => {
    const stateObj = { ...formValue, [name]: value };
    setFormValue(stateObj);
    if (!utils.isObjectKeyEmpty(formError)) {
      const validationResult = await utils.checkFormError(
        stateObj,
        errorSchema.addExpenseCategorySchema
      );
      if (validationResult === true) {
        setFormError("");
      } else {
        setFormError(validationResult);
      }
    }
  };

  const apiCallingFunction = async () => {

    const customePayload = {
      company_id: StorageServices?.getCompanyId(),
      category_id: 5,
      sub_category_id: 1,
      name: formValue?.name
    }

    try {
      const res = await addExpenseApi(customePayload);
      if (res.responseCode === 200) {
        setFormValue({});
        setLoading(false);
        toast.success(res?.responseMessage);
        closeModal(false);
        callBackApi(res?.data);
      } else {
        setLoading(false);
        toast.error(res?.responseMessage);
      }
    } catch (error) {
      setLoading(false);
      toast.error(error);
    }
  };

  const handleClick = async (value) => {
    const validationResult = await utils?.checkFormError(
      formValue,
      errorSchema.addExpenseCategorySchema
    );

    if (utils?.isObjectKeyEmpty(validationResult)) {
      setLoading(true);
      apiCallingFunction();
      setFormError("");
    } else {
      setFormError(validationResult);
    }
  };

  useEffect(() => {
    if (isOpen) {
      setFormValue((s) => ({
        ...s,
        company_id: StorageService.getCompanyId(),
      }));
    }
  }, [isOpen]);

  const newCleanUpfunction = () => {
    setFormValue({});
    setFormError('');
    closeModal();
  }

  let inhanceProps = {
    ...props,
    closeModal: newCleanUpfunction,
    submitTitle: loading ? "Loading..." : props.submitTitle,
    disabled: loading,
    onSubmit: handleClick,
  };

  return (
    <div>
      <CommonModal {...inhanceProps}>
        <div className="addItem_body mt-2">
          <div className="colFlx">
            {titleName != 'branch' && <div className="singleDiv">
              <CommonInput
                type="text"
                label={label}
                placeholder={placeholder}
                name="name"
                value={formValue.name}
                focus={!!(typeof formError === "object" && formError?.name)}
                error={!!(typeof formError === "object") ? formError?.name : ""}
                onChange={({ target: { name, value } }) =>
                  handleOnChange(name, value)
                }
              />
            </div>}
            {titleName === 'fuel_card' && (
              <div className="singleDiv">
                <CustomSelect
                  options={fuelCardCompanyList}
                  label={isLabelData}
                  placeholder={isLabelData}
                  // label="Fastag Company"
                  // placeholder="Fastag Company"
                  name="fuelcard_company_id"
                  focus={!!formError?.fuelcard_company_id}
                  error={formError.fuelcard_company_id}
                  onSelect={(data) =>
                    handleOnChange("fuelcard_company_id", data?.value)
                  }
                  value={fuelCardCompanyList.find((i) => i?.value == formValue?.fuelcard_company_id)}
                />
              </div>
            )}

            {titleName === 'fastag' && (
              <CustomSelect
                options={fastagCompanyList || []}
                label={isLabelData}
                placeholder={isLabelData}
                // label="Fastag Company"
                // placeholder="Fastag Company"
                name="fastag_company_id"
                focus={!!formError?.fastag_company_id}
                error={formError.fastag_company_id}
                onSelect={(data) =>
                  handleOnChange("fastag_company_id", data?.value)
                }
                value={fastagCompanyList?.find((i) => i?.value == formValue?.fastag_company_id)}
              />
            )}

            {
              titleName === 'branch' && (
                <div className="singleDiv">
                  <CustomSelect
                    options={branchList.filter((i) => i?.value != "")}
                    label={isLabelData}
                    placeholder={placeholder}
                    // label="Fastag Company"
                    // placeholder="Fastag Company"
                    name="branch_id"
                    focus={!!formError?.branch_id}
                    error={formError.branch_id}
                    onSelect={(data) =>
                      handleOnChange("branch_id", data?.value)
                    }
                    value={branchList.find((i) => i?.value == formValue?.branch_id)}
                  />
                </div>
              )}
          </div>
        </div>
      </CommonModal>
      <div className='offBack_drop'></div>
    </div>
  );
};

export default React.memo(AddExpenseCategoryModal);
